import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { DietDetailsPage, DietsPage } from './pages'

const DietsRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.DIETS.link}
      permissions={[PERMISSIONS.METADATA_TREE.LIST]}
      component={DietsPage}
    />
    <PermissionRoute
      exact
      path={APP_ROUTES.DIET_DETAILS.link}
      permissions={[PERMISSIONS.METADATA_TREE.GET]}
      component={DietDetailsPage}
    />
  </Switch>
)

export default DietsRouter
